module.exports = __webpack_public_path__ + "static/media/z.247e17fc.JPG";